import { render, staticRenderFns } from "./CommentsFlow.vue?vue&type=template&id=bc452bd8&"
import script from "./CommentsFlow.vue?vue&type=script&lang=js&"
export * from "./CommentsFlow.vue?vue&type=script&lang=js&"
import style0 from "./CommentsFlow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc452bd8')) {
      api.createRecord('bc452bd8', component.options)
    } else {
      api.reload('bc452bd8', component.options)
    }
    module.hot.accept("./CommentsFlow.vue?vue&type=template&id=bc452bd8&", function () {
      api.rerender('bc452bd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/informationFlow/CommentsFlow.vue"
export default component.exports